import angular from 'angular';
import toastr from 'angular-toastr';
import gettext from 'angular-gettext';
import TemplateResource from '../../../cmsCore/TemplatesModules/TemplateResource';

export default angular.module('cms.export.as.template.dialog.service', [toastr, gettext, TemplateResource])
    .factory('exportAsTemplateDialog', ($uibModal, $q) => {

        let service = {};

        service.open = (page) => {
            let modalInstance = $uibModal.open({
                animation: true,
                template: require('../templates/exportAsTemplateDialog.html'),
                size: 'md',
                controllerAs: '$ctrl',
                controller: function ($scope, TemplateResource, toastr, gettextCatalog) {
                    this.errors = {};
                    this.pending = false;
                    this.template = {
                        title: page.title,
                        slug: page.slug,
                        content: page.content,
                        globalBackgroundColor: page.globalBackgroundColor,
                        globalBackgroundImage: page.globalBackgroundImage,
                        globalColor: page.globalColor,
                        globalLinkColor: page.globalLinkColor,
                        globalTextConfig: page.globalTextConfig,
                        globalTabletBackgroundImage: page.globalTabletBackgroundImage,
                        globalMobileBackgroundImage: page.globalMobileBackgroundImage,
                        customStyles: page.customStyles,
                        globalLineHeight: page.globalLineHeight,
                        page: page,
                        accessibleByEveryone: true
                    };

                    this.export = () => {
                        this.pending = true;
                        return TemplateResource.save(this.template,
                            response => {
                                this.errors = {};
                                toastr.success(
                                    gettextCatalog.getString('Template {{title}} added!', {title: this.template.title}),
                                    gettextCatalog.getString('Success')
                                );
                                this.pending = false;
                                $scope.$close(response);
                            },
                            response => {
                                if (response.status === 400) {
                                    this.errors = response.data;
                                }
                                this.pending = false;
                            }
                        ).$promise;


                    };
                }

            });

            return modalInstance.result;
        };

        return service;

    }).name


// WEBPACK FOOTER //
// ./src/cmsPages/Pages/Services/ExportAsTemplateDialog.js